import styled from 'styled-components'

export const StyledIconContainer = styled.div`
	display: flex;
	* {
		margin-right: 10px;
	}
`